import { render, staticRenderFns } from "./PchProviderAccountBankList.vue?vue&type=template&id=3acc22d5&lang=pug&"
import script from "./PchProviderAccountBankList.vue?vue&type=script&lang=js&"
export * from "./PchProviderAccountBankList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PchProviderAccountBankList.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
installComponents(component, {
  VCard,
})
